import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FooterContainer = styled.footer`
  background-color: var(--color-bg-dark);
  padding: 3rem 0;
  position: relative;
  z-index: 5;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const FooterColumn = styled.div`
  h3 {
    color: var(--color-text);
    margin-bottom: 1.5rem;
    font-size: 1.2rem;
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      bottom: -0.5rem;
      left: 0;
      width: 40px;
      height: 2px;
      background-color: var(--color-primary);
    }
  }
  
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  li {
    margin-bottom: 0.75rem;
  }
  
  a {
    color: var(--color-text-secondary);
    text-decoration: none;
    transition: all 0.2s ease;
    
    &:hover {
      color: var(--color-primary);
      padding-left: 5px;
    }
  }
  
  p {
    color: var(--color-text-secondary);
    line-height: 1.6;
    margin-bottom: 1rem;
  }
`;

const Copyright = styled.div`
  text-align: center;
  color: var(--color-text-tertiary);
  padding-top: 3rem;
  font-size: 0.9rem;
  
  a {
    color: var(--color-primary);
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <FooterContent>
        <FooterColumn>
          <h3>Blagman Brothers Vintage Music</h3>
          <p>
            Authentic vintage music from the 1950s and 1960s.
            Professional licensing for films, commercials, and creative projects.
          </p>
                  </FooterColumn>
        
        <FooterColumn>
          <h3>Explore</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/catalog">Music Catalog</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/licensing">Licensing</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </FooterColumn>
        
        <FooterColumn>
          <h3>Resources</h3>
          <ul>
            <li><a href="#">Licensing Guide</a></li>
            <li><a href="#">FAQ</a></li>
            <li><a href="#">Blog</a></li>
            <li><a href="#">Privacy Policy</a></li>
            <li><a href="#">Terms of Service</a></li>
          </ul>
        </FooterColumn>
        
        <FooterColumn>
          <h3>Contact</h3>
          <p>
            Los Angeles, CA<br />
            United States
          </p>
          <p>
            Email: contact@blagmanbros.com<br />
            Phone: 310 621-9318
          </p>
        </FooterColumn>
      </FooterContent>
      
      <Copyright>
        <p>© {currentYear} Blagman Brothers Vintage Music. All rights reserved.</p>
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;